import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPortfolio_details, getSocial_link, getproject_list, getExperience_list } from '../config/firebase.db';

const DataContext = createContext();

export const useData = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [portfolio, setPortfolio] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [experience, setExperience] = useState([]);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const fetchAllData = async () => {
      const totalSteps = 4;
      let completed = 0;

      const updateProgress = () => {
        completed++;
        setLoadingProgress(Math.round((completed / totalSteps) * 100));
      };

      try {
        const portfolioData = await getPortfolio_details();
        setPortfolio(portfolioData);
        updateProgress();

        const socialData = await getSocial_link();
        setSocialLinks(socialData);
        updateProgress();

        const projectData = await getproject_list();
        setProjects(projectData);
        updateProgress();

        const experienceData = await getExperience_list();
        setExperience(experienceData);
        updateProgress();
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadingProgress(100);
      }

      setDataLoaded(true);
    };

    fetchAllData();
  }, []);

  return (
    <DataContext.Provider value={{
      portfolio,
      socialLinks,
      projects,
      experience,
      loadingProgress,
      dataLoaded
    }}>
      {children}
    </DataContext.Provider>
  );
};
